import { render, staticRenderFns } from "./CertificateCardSkeleton.vue?vue&type=template&id=139bf7f6&scoped=true"
import script from "./CertificateCardSkeleton.vue?vue&type=script&lang=js"
export * from "./CertificateCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CertificateCardSkeleton.vue?vue&type=style&index=0&id=139bf7f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139bf7f6",
  null
  
)

export default component.exports